import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/src/Fancybox/Fancybox.scss";

class ImageZoom {
    init() {
        Fancybox.bind("[data-fancybox]", {});
        Fancybox.bind('[data-fancybox="gallery"]', {});
        Fancybox.bind(".js-image-zoom a", {});
        Fancybox.bind(".js-contentEditor img", {});
    }

    refresh() {
        this.init();
    }
}

export default new ImageZoom();
